// extracted by mini-css-extract-plugin
export default {"modalTitle":"ModalPaymentInfoVersion2_modalTitle__QkGEX","printModalTitle":"ModalPaymentInfoVersion2_printModalTitle__BCe02"};